export default {
  slug: 'intelligence-extractor',
  title: 'Indicator extractor',
  description: 'Pull IOCs from chats, emails, and reports.',
  section: 'intelligence',
  order: 2,
  tags: ['extractor', 'ioc', 'promote'],
  body: `# Indicator extractor

Extract structured indicators from unstructured text — chat logs, email threads, scam scripts, or analyst notes.

## Open the tool

Go to **[Intelligence → Extractor](/intelligence/extractor)** or use the quick card on the search home page.

## Workflow

1. **Paste** the source text into the textarea.
2. Click **Extract** — the engine returns categorized IOCs (emails, IPs, domains, wallets, phones, etc.).
3. Review the table: type, value, category.
4. Use **Select all** / **Clear** for bulk selection (bulk promote coming in a future pass).
5. Click **Promote** on any row to create an indicator (optionally linked to a case).

Recently promoted indicators appear as pivot links below the table.

## Extraction categories

The extractor groups findings by category with counts. Each item includes:

- \`ioc_type\` — normalized type used in the indicator registry
- \`value\` — raw matched string
- \`category\` — human-readable label (e.g. "Email Addresses")

## Linking to searches

When promoting from a search result context, pass \`search_id\` so the platform records a \`promoted_from\` link between the search and the new indicator.

## Best practices

- Sanitize PII before pasting if sharing extracts outside the platform.
- Promote high-confidence IOCs first, then attach lower-confidence items after analyst review.
- After promotion, open the **[indicator detail](/indicators)** page to run enrichment or add to a case timeline.
`,
};
